import { useUserRoleStrict } from 'hooks/useUserRole';

export const useSettingsPageHasSheduleEditor = () => {
  const role = useUserRoleStrict();

  return role === 'ADMINISTRATOR' || role === 'MANAGER';
};
